import { render } from "./Forbidden.vue?vue&type=template&id=0ee8184c"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"

import "./Forbidden.vue?vue&type=style&index=0&id=0ee8184c&lang=css"

import exportComponent from "D:\\DEV\\STATIC\\player-speakup\\player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__